export const toEnglishNumber = (strNum) => {
    let pn = ["Û°", "Û±", "Û²", "Û³", "Û´", "Ûµ", "Û¶", "Û·", "Û¸", "Û¹"];
    let en = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];
    let an = ["Ù ", "Ù¡", "Ù¢", "Ù£", "Ù¤", "Ù¥", "Ù¦", "Ù§", "Ù¨", "Ù©"];
    let cache = strNum;
    for (let i = 0; i < 10; i++) {
        let regex_fa = new RegExp(pn[i], 'g');
        let regex_ar = new RegExp(an[i], 'g');
        cache = cache.replace(regex_fa, en[i]);
        cache = cache.replace(regex_ar, en[i]);
    }
    return cache;
}

export const toPersianNumber = (strNum) => {
    let en = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];
    let pn = ["Û°", "Û±", "Û²", "Û³", "Û´", "Ûµ", "Û¶", "Û·", "Û¸", "Û¹"];
    let cache = strNum;
    for (let i = 0; i < 10; i++) {
        let regex_en = new RegExp(en[i], 'g');
        cache = cache.replace(regex_en, pn[i]);
    }
    return cache;
};